<script>
    import { LottiePlayer } from "@lottiefiles/svelte-lottie-player";
    import cardData from "./cardData.json";
    export let itemSelected = "";
    import animationData from "../../../../public/images/chillSun.json";
    import { screenStore } from "../../../functions/stores";
    $: selected = cardData.data.filter((v) => {
        console.log(itemSelected.item?.toLowerCase().trim());
        return (
            v.name.toLowerCase().trim() ==
            itemSelected.item?.toLowerCase().trim()
        );
    });
</script>

<div
    class={$screenStore.width < 500
        ? "min-[320px]:px-10 md:space-x-16 "
        : "flex justify-center space-x-16 px-20"}
>
    <div class={$screenStore.width < 500 ? "flex justify-center" : ""}>
        <div
            class="card h-72 w-72 p-10 rounded-3xl shadow-lg text-slate-500 text-lg font-semibold"
        >
            {selected[0]?.message}
        </div>
    </div>
    <div class=" min-[320px]:pt-5" style="z-index: 2;">
        <LottiePlayer
            src={animationData}
            autoplay={true}
            loop={true}
            controls={false}
            renderer="svg"
            background="transparent"
            height={$screenStore.width < 500 ? 200 : 400}
            width={$screenStore.width < 300
                ? 270
                : $screenStore.width < 500
                ? 380
                : 400}
        />
    </div>
</div>

<style>
 
</style>
